/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Outreach_Copylink_Accessinfo4Inputs */

const en_coinvestments_outreach_copylink_accessinfo4 = /** @type {(inputs: Coinvestments_Outreach_Copylink_Accessinfo4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you've shared this link outside the platform, ensure you grant access to your recipient in the table below.`)
};

/**
* | output |
* | --- |
* | "If you've shared this link outside the platform, ensure you grant access to your recipient in the table below." |
*
* @param {Coinvestments_Outreach_Copylink_Accessinfo4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_outreach_copylink_accessinfo4 = /** @type {((inputs?: Coinvestments_Outreach_Copylink_Accessinfo4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Outreach_Copylink_Accessinfo4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_outreach_copylink_accessinfo4(inputs)
});
export { coinvestments_outreach_copylink_accessinfo4 as "coInvestments_outreach_copyLink_AccessInfo" }